import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment-timezone";
import "moment/locale/en-gb";
import "moment-duration-format";
import { FaStarAndCrescent } from "react-icons/fa";
import { useFeatureFlagEnabled } from 'posthog-js/react'

function Countdown() {
  const [countdown, setCountdown] = useState("");
  const flagEnabled = useFeatureFlagEnabled('eid-sale')
  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      const end = flagEnabled
        ? moment("2025-06-12") // Eid countdown to specific date
        : moment().endOf('day'); // Regular daily countdown to end of day
      const duration = moment.duration(end.diff(now));
      setCountdown(duration.format("D[d] H[h] m[m] s[s]"));
    }, 1000);
    return () => clearInterval(interval);
  }, [flagEnabled]);
  return (
    <div className="p-2 mt-2 text-white font-bold mb-4 flex justify-center space-x-2 items-center bg-red-600 rounded-lg select-none" title="Discount applied to select product. Enjoy!">
      <span className="">
        {flagEnabled && <FaStarAndCrescent />}
      </span>
      <span>
        {flagEnabled ? `Eid Offer Ends in ${countdown}` : `Offer Ends in ${countdown}`}
      </span>
    </div>
  );
}

export default Countdown;
